import {
  ARTICLE_DESTINATION,
  BENEFIT_DESTINATION,
  CALENDAR_EVENT_DESTINATION,
  GIFT_DESTINATION,
  HELP_SCREEN_DESTINATION,
  ONLINE_SERVICE_DESTINATION,
  STORE_DESTINATION,
  USER_BARCODE_DESTINATION,
  USER_PROFILE_DESTINATION,
  USER_SETTINGS_DESTINATION,
} from '@esentai/core/features/campaigns/button/consts/destinations';
import {
  DESTINATION_KEY,
  REFERRED_ARTICLE_ID_KEY,
  REFERRED_BENEFIT_ID_KEY,
  REFERRED_CALENDAR_EVENT_ID_KEY,
  REFERRED_STORE_ID_KEY,
} from '@esentai/core/features/campaigns/button/consts/keys';
import {
  ARTICLE_TYPE,
  CALENDAR_EVENT_TYPE,
} from '@esentai/core/features/campaigns/consts/types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import React, { Component } from 'react';

import FieldDescription from '@/components/FieldDescription';
import FieldRow from '@/components/FieldRow';
import RadioBox, { RadioBoxGroup } from '@/components/RadioTile';
import FormikPropTypes from '@/prop-types/formik';

import { CanEdit, CanEditRadioBoxGroup } from '../../CanEdit';
import BenefitInlineSearch from '../../SecondStepBanner/BenefitInlineSearch';
import CampaignInlineSearch from '../../SecondStepBanner/CampaignInlineSearch';
import StoreInlineSearch from '../../SecondStepBanner/StoreInlineSearch';

class DestinationForm extends Component {
  static propTypes = FormikPropTypes;

  handleDestinationChange = event => {
    const { value } = event.target;

    this.clearReferredValues();
    this.setDestination(value);
  };

  clearReferredValues = () => {
    const { setFieldValue } = this.props;

    setFieldValue(REFERRED_ARTICLE_ID_KEY, null);
    setFieldValue(REFERRED_CALENDAR_EVENT_ID_KEY, null);
    setFieldValue(REFERRED_STORE_ID_KEY, null);
  };

  toggleDestination = () => {
    const { values } = this.props;
    const destination = values[DESTINATION_KEY];

    if (destination) {
      this.clearDestination();
    } else {
      this.setDestination(ARTICLE_DESTINATION);
    }
  };

  clearDestination = () => {
    this.setDestination(null);
  };

  setDestination = value => {
    const { setFieldValue } = this.props;

    setFieldValue(DESTINATION_KEY, value);
  };

  setReferredCampaignId = (key, value) => {
    const { setFieldValue } = this.props;

    setFieldValue(key, value);
  };

  setBenefitId = value => {
    const { setFieldValue } = this.props;

    setFieldValue(REFERRED_BENEFIT_ID_KEY, value);
  };

  setStoreId = value => {
    const { setFieldValue } = this.props;

    setFieldValue(REFERRED_STORE_ID_KEY, value);
  };

  render() {
    const { values } = this.props;
    const destination = values[DESTINATION_KEY];
    const campaignType = this.getType();

    return (
      <FieldRow
        label="Точка назначения"
        subLabel="Является ли кнопка ссылкой?"
        sudDesc="???"
      >
        <CanEdit field={DESTINATION_KEY}>
          <FormControlLabel
            label="Кнопка ссылается на другую точку в приложении"
            control={
              <Checkbox
                checked={Boolean(destination)}
                onChange={this.toggleDestination}
              />
            }
          />
        </CanEdit>

        {destination ? (
          <div>
            <FieldDescription
              title="Точка назначения кнопка"
              desc="Укажите, куда именно ссылается кнопка."
            />
            <CanEditRadioBoxGroup field={DESTINATION_KEY}>
              <RadioBoxGroup
                name={DESTINATION_KEY}
                value={destination}
                onChange={this.handleDestinationChange}
              >
                <RadioBox
                  value={ARTICLE_DESTINATION}
                  label="Статья"
                  helperText="Кнопка будет ссылаться на другое, уже существующее и опубликованное, рекламное размещение-статью."
                />
                <RadioBox
                  value={BENEFIT_DESTINATION}
                  label="Бенефит"
                  helperText="Кнопка будет ссылаться на уже существующий и опубликованный бенефит."
                />
                <RadioBox
                  value={GIFT_DESTINATION}
                  label="Гифт"
                  helperText="Кнопка будет ссылаться на уже существующий и опубликованный гифт."
                />
                <RadioBox
                  value={CALENDAR_EVENT_DESTINATION}
                  label="Календарное событие"
                  helperText="Кнопка будет ссылаться на уже существующее и опубликованное  календарное событие."
                />
                <RadioBox
                  value={STORE_DESTINATION}
                  label="Магазин"
                  helperText="Кнопка будет ссылаться на уже существующий и работающий магазин."
                />
                <RadioBox
                  value={ONLINE_SERVICE_DESTINATION}
                  label="Онлайн сервис"
                  helperText="Кнопка будет ссылаться на уже существующий в приложении онлайн сервис."
                />
                <RadioBox
                  value={USER_PROFILE_DESTINATION}
                  label="Профиль пользователя"
                  helperText="Кнопка будет ссылаться на экран профиля пользователя в мобильном приложении."
                />
                <RadioBox
                  value={USER_SETTINGS_DESTINATION}
                  label="Настройки пользователя"
                  helperText="Кнопка будет ссылаться на экран настроек аккаунта пользователя в мобильном приложении."
                />
                <RadioBox
                  value={USER_BARCODE_DESTINATION}
                  label="Баркод пользователя"
                  helperText="Кнопка будет ссылаться на экран баркода пользователя в мобильном приложении."
                />
                <RadioBox
                  value={HELP_SCREEN_DESTINATION}
                  label="Экран помощи"
                  helperText="Кнопка будет ссылаться на экран помощи в мобильном приложении."
                />
              </RadioBoxGroup>
            </CanEditRadioBoxGroup>
            <CanEdit field={DESTINATION_KEY}>
              {campaignType && (
                <CampaignInlineSearch
                  values={values}
                  onSelect={this.setReferredCampaignId}
                  type={campaignType}
                />
              )}

              {destination === BENEFIT_DESTINATION ? (
                <BenefitInlineSearch
                  value={values[REFERRED_BENEFIT_ID_KEY]}
                  onSelect={this.setBenefitId}
                />
              ) : null}

              {destination === STORE_DESTINATION ? (
                <StoreInlineSearch
                  value={values[REFERRED_STORE_ID_KEY]}
                  onSelect={this.setStoreId}
                />
              ) : null}
            </CanEdit>
          </div>
        ) : null}
      </FieldRow>
    );
  }

  getType() {
    const { values } = this.props;

    const mapping = {
      [ARTICLE_DESTINATION]: ARTICLE_TYPE,
      [CALENDAR_EVENT_DESTINATION]: CALENDAR_EVENT_TYPE,
    };

    const destination = values[DESTINATION_KEY];

    return mapping[destination];
  }
}

export default DestinationForm;
